import React from 'react'
import { useTranslation } from "contexts/Safra/TranslationContext";
import { isChannel } from "../../../utils";
import {
  Container,
  AttendanceSection,
  AttendanceTitle,
  ContactsContainer,
  ContactBox,
  Divider,
  PaymentSection,
  PaymentTitle,
  PaymentSubtitle,
  LogosContainer,
  LogoWrapper,
  HelpSection,
  HelpTitle,
  HelpList,
  HelpItem,
} from './styles'
import Icon from 'components/Safra/Icon';
import VisaLogo from '../../../assets/img/logos_visa.svg'
import MastercardLogo from '../../../assets/img/logos_mastercard.svg'

export default function Footer() {
  const { t } = useTranslation();

  const isSafra = isChannel('safra');

  const redirectParent = (path) => {
    let parentOrigin = '';
    try {
      if (document.referrer) {
        parentOrigin = new URL(document.referrer).origin;
      }
    } catch (e) {
      parentOrigin = '';
    }
    window.top.location.href = `${parentOrigin}${path}`;
  };

  const helpItems = [
    {
      key: 'orders',
      icon: 'list',
      label: t('safra.components.footer.help.orders'),
      enabled: true,
      onClick: () => redirectParent('/loja/myrequests'),
    },
    {
      key: 'help_center',
      icon: 'message-circle',
      label: t('safra.components.footer.help.help_center'),
      enabled: true,
      onClick: () => redirectParent('/loja/policy'),
    },
    {
      key: 'phone',
      icon: 'phone',
      label: t('safra.components.footer.help.phone'),
      enabled: false,
      onClick: () => {},
    },
    {
      key: 'email',
      icon: 'mail',
      label: t('safra.components.footer.help.email'),
      enabled: false,
      onClick: () => {},
    },
    {
      key: 'whatsapp',
      icon: 'whatsapp',
      label: t('safra.components.footer.help.whatsapp'),
      subtitle: t('safra.components.footer.help.whatsapp_hours'),
      enabled: false,
      onClick: () => {},
    },
  ];

  return (
    <Container>
      {isSafra ? (
        <AttendanceSection>
          <AttendanceTitle>
            {t('safra.components.footer.attendance_title')}
          </AttendanceTitle>

          <ContactsContainer>
            <ContactBox>
              <p>(11) 4001-4460</p>
              <p>{t('safra.components.footer.sp_region')}</p>
            </ContactBox>

            <Divider />

            <ContactBox>
              <p>0800 728 4460</p>
              <p>{t('safra.components.footer.other_regions')}</p>
            </ContactBox>
          </ContactsContainer>
        </AttendanceSection>
      ) : (
        <HelpSection>
          <HelpTitle>{t('safra.components.footer.help.title')}</HelpTitle>

          <HelpList>
            {helpItems.filter((item) => item.enabled).map((item) => (
              <HelpItem
                key={item.key}
                type="button"
                onClick={item.onClick}
              >
                <Icon className="help-item-icon" name={item.icon} size={24} color="var(--primary-color)" />
                <span className="help-item-content">
                  <span className="help-item-label">{item.label}</span>
                  {item.subtitle && (
                    <span className="help-item-subtitle">{item.subtitle}</span>
                  )}
                </span>
                <Icon className="help-item-chevron" name="chevron-right" size={20} color="#9DA1A6" />
              </HelpItem>
            ))}
          </HelpList>
        </HelpSection>
      )}

      {isSafra && (
        <PaymentSection>
          <PaymentTitle>{t('safra.components.footer.payment_methods')}</PaymentTitle>

          <PaymentSubtitle>{t('safra.components.footer.payment_subtitle')}</PaymentSubtitle>

          <LogosContainer>
            <LogoWrapper>
              <img src={VisaLogo} alt="Visa" />
            </LogoWrapper>
            <LogoWrapper isMastercard>
              <img src={MastercardLogo} alt="Mastercard" />
            </LogoWrapper>
          </LogosContainer>
        </PaymentSection>
      )}
    </Container>
  )
}
